import { css } from '@emotion/react';

import Link from '../../ComponentLibrary/oc-button';
import { connectLocation } from '../../location/LocationConnectors';

const styles = css`
  width: 50%;
  margin-left: 25%;
  margin-right: 25%;

  @media (max-width: 767px) {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const ContactUs = connectLocation(({ t }) => (
  <section css={styles}>
    <h2>{t('components.get_in_touch.heading')}</h2>
    <p>{t('components.get_in_touch.text')}</p>
    <Link
      color="white"
      href="https://makemorepossible.glass"
      data-track="contact-us-cta"
      title={t('components.get_in_touch.cta')}
    >
      {t('components.get_in_touch.cta')}
    </Link>
  </section>
));

ContactUs.WrappedComponent.displayName = 'ContactUs';

export default ContactUs;
